import { instance } from "api/apiBase";

interface AffordableHousingComStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL =
  "/portal/v1/external_integrations/affordable_housing_com";

export const affordableHousingComApi = {
  getStatus: async (): Promise<AffordableHousingComStatusResponse> => {
    const { data } =
      await instance.get<AffordableHousingComStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<AffordableHousingComStatusResponse> => {
    const { data } =
      await instance.post<AffordableHousingComStatusResponse>(
        BASE_ENDPOINT_URL
      );
    return data;
  },

  disconnect: async (): Promise<AffordableHousingComStatusResponse> => {
    const { data } =
      await instance.delete<AffordableHousingComStatusResponse>(
        BASE_ENDPOINT_URL
      );
    return data;
  }
};
